import { ALL_LANGUAGES, DEFAULT_LANGUAGE } from 'constants/LanguageConstants';

import { createLabel } from 'utils/utils';

const brand = {
  s3LogoPath: '/brands/bmw/bmw.png',
  name: 'BMW',
  id: '5525364c-0dd6-339c-9227-94a17ddf5800',
};

const sentBy = {
  displayName: 'Admin Doe',
  email: 'admin.doe@arhs.com',
  tel: '0699999999',
};

const vehicleInfo = {
  model: 'CUSTOM TEMPLATE',
  registration: '1PNU215',
  mileage: 12500,
  vin: 'KV135482BN451',
  fuelType: 'GASOLINE',
};

const message = 'Following your visit in our workshop, please find hereafter a message from our customer service.';

const categoryName = createLabel('Others');

const customerInfo = {
  lastName: 'MAROT',
  civility: 'MR',
  language: DEFAULT_LANGUAGE,
  displayName: 'MAROT',
};

const author = {
  displayName: 'Admin Doe',
  email: 'admin.doe@arhs.com',
};

const checklists = [
  {
    items: [
      {
        advices: [
          {
            adviceId: 'advice1',
            adviceName: createLabel('Front pads and disks'),
            price: 32.24,
            discount: 0,
            discountedPrice: 0,
            severity: 'LOW',
            coefficient: 1,
          },
          {
            adviceId: 'advice2',
            adviceName: createLabel('Rear pads and disks'),
            price: 30.24,
            discount: 0,
            discountedPrice: 0,
            severity: 'HIGH',
            coefficient: 1,
          },
          {
            adviceId: 'advice3',
            adviceName: createLabel('Front washers'),
            price: 60.5,
            discount: 0,
            discountedPrice: 0,
            severity: 'LOW',
            coefficient: 1,
          },
          {
            adviceId: 'advice4',
            adviceName: createLabel('Rear washers'),
            price: 60.5,
            discount: 10,
            discountedPrice: 50.5,
            severity: 'HIGH',
            coefficient: 1,
            hasDiscount: true,
          },
          {
            adviceId: 'advice5',
            adviceName: createLabel('Windshield'),
            price: 242,
            discount: 0,
            discountedPrice: 0,
            severity: 'HIGH',
            coefficient: 1,
          },
        ],
        price: 0,
      },
    ],
    type: 'WORK',
    price: 925.8333333333334,
    default: true,
    languages: ALL_LANGUAGES,
  },
];

const checklistsSales = [
  {
    name: 'Vehicle Default',
    items: [
      {
        advices: [
          {
            adviceId: '05abbde4-6a8c-46e4-b4b1-e73bff7fcfda',
            adviceName: createLabel('BMW M3'),
            category: 'CAR',
            coefficient: 1,
            price: 100000,
            discount: 0,
            severity: 'PROPOSED',
            accepted: false,
            imported: false,
            status: 'PENDING',
            proposed: true,
            discountedPrice: 100000,
            hasDiscount: false,
          },
        ],
        categoryId: 'd0375dbb-9a9c-4825-97de-ef357aa58a4f',
        categoryName,
        others: true,
        price: 100000,
      },
    ],
    type: 'VEHICLE',
    offeredChecklist: false,
    price: 100000,
    default: true,
    languages: ALL_LANGUAGES,
  },
  {
    name: 'ACCESSORIES',
    items: [
      {
        advices: [
          {
            adviceId: 'd9be48f8-e3a7-43bc-b034-c2109b601f7c',
            adviceName: createLabel('Leather steering wheel'),
            category: 'OPTION',
            coefficient: 1,
            price: 500.05,
            discount: 0,
            severity: 'PROPOSED',
            accepted: false,
            imported: false,
            status: 'PENDING',
            proposed: true,
            discountedPrice: 500.05,
            hasDiscount: false,
          },
          {
            adviceId: '4962a102-f4f2-45f9-9844-d00e734c1b36',
            adviceName: createLabel('Disks'),
            category: 'SERVICE',
            coefficient: 1,
            price: 100,
            discount: 0,
            severity: 'PROPOSED',
            accepted: false,
            imported: false,
            status: 'PENDING',
            proposed: true,
            discountedPrice: 100,
            hasDiscount: false,
          },
          {
            adviceId: '4bcd409e-b97a-44c5-a2cf-b036883d1ca2',
            adviceName: createLabel('Front pads'),
            category: 'DISCOUNT',
            coefficient: 1,
            price: 5000,
            discount: 0,
            severity: 'OFFERED',
            accepted: false,
            imported: false,
            status: 'PENDING',
            proposed: true,
            discountedPrice: 5000,
            hasDiscount: false,
          },
        ],
        categoryId: 'fb636869-56c7-49cf-a473-12f9372e8de5',
        categoryName,
        others: false,
        price: 5600.05,
      },
    ],
    type: 'ACCESSORY',
    offeredChecklist: false,
    price: 5600.05,
    default: true,
    languages: ALL_LANGUAGES,
  },
  {
    name: 'Trade-in Default',
    items: [
      {
        advices: [
          {
            adviceId: 'e1760166-06ef-4e93-9bbd-dcd7bc3c3904',
            adviceName: createLabel('Mini'),
            category: 'TRADE_IN',
            coefficient: -1,
            price: 5000,
            discount: 0,
            severity: 'PROPOSED',
            accepted: false,
            imported: false,
            status: 'PENDING',
            proposed: true,
            discountedPrice: 5000,
            hasDiscount: false,
          },
        ],
        categoryId: '3017c6e2-a928-4e99-abb3-9bb4c46329ad',
        categoryName,
        others: true,
        price: 5000,
      },
    ],
    type: 'TRADE_IN',
    offeredChecklist: false,
    price: 5000,
    default: true,
    languages: ALL_LANGUAGES,
  },
  {
    name: 'Discount Default',
    items: [
      {
        advices: [
          {
            adviceId: '254de253-942a-40ea-a148-92a2134c753a',
            adviceName: createLabel('Vehicle bonus'),
            category: 'DISCOUNT',
            coefficient: -1,
            price: 1000,
            discount: 0,
            severity: 'PROPOSED',
            accepted: false,
            imported: false,
            status: 'PENDING',
            proposed: true,
            discountedPrice: 1000,
            hasDiscount: false,
          },
        ],
        categoryId: '0e6b466b-8173-4b58-a016-e627a6c9bb4c',
        categoryName,
        others: true,
        price: 1000,
      },
    ],
    type: 'DISCOUNT',
    offeredChecklist: false,
    price: 1000,
    default: true,
    languages: ALL_LANGUAGES,
  },
];

const parts = {
  checklistGroups: [
    {
      id: 'offer1id',
      name: 'Offer 1',
      status: 'PENDING'
    },
    {
      id: 'offer2id',
      name: 'Offer 2',
      status: 'PENDING'
    },
    {
      id: 'offer3id',
      name: 'Offer 3',
      status: 'PENDING'
    }
  ],
  checklists: [
    {
      checklistGroupId: 'offer3id',
      items: [
        {
          advices: [
            {
              adviceId: 'bf10fb73-0893-4687-a0d3-4705e522ad9c',
              adviceName: createLabel('Battery'),
              authorId: 'f17ec42b-eec4-4df1-a737-6a13bc4f6f58',
              coefficient: 1,
              createdOn: '2023-11-24T08:48:29.566Z',
              depositPercentage: 0,
              discount: 2.9999999999999996,
              highlighted: true,
              imported: false,
              mandatory: false,
              price: 59.99999999999999,
              senderId: '0136b092-3d30-4e19-b645-e7ff48f1a762',
              sentOn: '2023-11-24T08:48:32.127Z',
              severity: 'PROPOSED',
              status: 'PENDING',
              version: 0,
              accepted: false,
              refused: false,
              proposed: true,
              discountedPrice: 56.99999999999999,
              hasDiscount: true,
              pending: true
            },
            {
              adviceId: '50b6a684-a027-4668-9dfb-a8304d18d210',
              adviceName: createLabel('Windscreen wiper'),
              authorId: 'f17ec42b-eec4-4df1-a737-6a13bc4f6f58',
              coefficient: 1,
              createdOn: '2023-11-24T08:48:29.566Z',
              depositPercentage: 0,
              discount: 0,
              highlighted: false,
              imported: false,
              mandatory: false,
              price: 40,
              senderId: '0136b092-3d30-4e19-b645-e7ff48f1a762',
              sentOn: '2023-11-24T08:48:32.127Z',
              severity: 'OFFERED',
              status: 'PENDING',
              version: 0,
              accepted: false,
              refused: false,
              proposed: true,
              discountedPrice: 40,
              hasDiscount: false,
              pending: true
            },
            {
              adviceId: '0ab2a41e-9911-4323-8d7c-08370cbf4b0a',
              adviceName: createLabel('Brakes'),
              authorId: 'f17ec42b-eec4-4df1-a737-6a13bc4f6f58',
              coefficient: 1,
              createdOn: '2023-11-24T08:48:29.566Z',
              depositPercentage: 0,
              discount: 10,
              highlighted: false,
              imported: false,
              mandatory: false,
              price: 99.99999999999999,
              senderId: '0136b092-3d30-4e19-b645-e7ff48f1a762',
              sentOn: '2023-11-24T08:48:32.127Z',
              severity: 'PROPOSED',
              status: 'PENDING',
              version: 0,
              accepted: false,
              refused: false,
              proposed: true,
              discountedPrice: 89.99999999999999,
              hasDiscount: true,
              pending: true
            },
            {
              adviceId: 'dc3d72c2-5352-49a6-9d36-c25062671bb4',
              adviceName: createLabel('Handbrake'),
              authorId: 'f17ec42b-eec4-4df1-a737-6a13bc4f6f58',
              coefficient: 1,
              createdOn: '2023-11-24T08:48:29.566Z',
              depositPercentage: 0,
              discount: 0,
              highlighted: false,
              imported: false,
              mandatory: false,
              price: 200,
              senderId: '0136b092-3d30-4e19-b645-e7ff48f1a762',
              sentOn: '2023-11-24T08:48:32.127Z',
              severity: 'PROPOSED',
              status: 'PENDING',
              version: 0,
              accepted: false,
              refused: false,
              proposed: true,
              discountedPrice: 200,
              hasDiscount: false,
              pending: true
            },
            {
              adviceId: '88774018-af27-4f6d-bcb7-32d42e61b33d',
              adviceName: createLabel('Airbag'),
              authorId: 'f17ec42b-eec4-4df1-a737-6a13bc4f6f58',
              coefficient: 1,
              createdOn: '2023-11-24T08:48:29.566Z',
              depositPercentage: 0,
              discount: 0,
              highlighted: false,
              imported: false,
              mandatory: false,
              price: 100,
              senderId: '0136b092-3d30-4e19-b645-e7ff48f1a762',
              sentOn: '2023-11-24T08:48:32.127Z',
              severity: 'PROPOSED',
              status: 'PENDING',
              version: 0,
              accepted: false,
              refused: false,
              proposed: true,
              discountedPrice: 100,
              hasDiscount: false,
              pending: true
            }
          ],
          categoryId: '657fd38d-553c-4543-befe-6918e67926f8',
          categoryName,
          others: true,
          price: 487
        }
      ],
      name: 'Parts',
      offeredChecklist: false,
      type: 'PARTS',
      price: 487,
      default: true,
      languages: ALL_LANGUAGES,
      projectionType: 'public',
    },
    {
      checklistGroupId: 'offer1id',
      items: [
        {
          advices: [
            {
              adviceId: 'ca8af342-f60c-4b7c-9293-f5b7818ea80b',
              adviceName: createLabel('Battery'),
              authorId: 'f17ec42b-eec4-4df1-a737-6a13bc4f6f58',
              coefficient: 1,
              createdOn: '2023-11-24T08:48:29.562Z',
              depositPercentage: 0,
              discount: 2.9999999999999996,
              highlighted: true,
              imported: false,
              mandatory: false,
              price: 59.99999999999999,
              senderId: '0136b092-3d30-4e19-b645-e7ff48f1a762',
              sentOn: '2023-11-24T08:48:32.131Z',
              severity: 'PROPOSED',
              status: 'PENDING',
              version: 0,
              accepted: false,
              refused: false,
              proposed: true,
              discountedPrice: 56.99999999999999,
              hasDiscount: true,
              pending: true
            },
            {
              adviceId: 'f96a86f5-0c32-4155-8bb6-67c37f001362',
              adviceName: createLabel('Windscreen wiper'),
              authorId: 'f17ec42b-eec4-4df1-a737-6a13bc4f6f58',
              coefficient: 1,
              createdOn: '2023-11-24T08:48:29.562Z',
              depositPercentage: 0,
              discount: 0,
              highlighted: false,
              imported: false,
              mandatory: false,
              price: 40,
              senderId: '0136b092-3d30-4e19-b645-e7ff48f1a762',
              sentOn: '2023-11-24T08:48:32.131Z',
              severity: 'OFFERED',
              status: 'PENDING',
              version: 0,
              accepted: false,
              refused: false,
              proposed: true,
              discountedPrice: 40,
              hasDiscount: false,
              pending: true
            },
            {
              adviceId: 'ad9a8e5c-08e8-42a4-8423-84c76b9abc6e',
              adviceName: createLabel('Brakes'),
              authorId: 'f17ec42b-eec4-4df1-a737-6a13bc4f6f58',
              coefficient: 1,
              createdOn: '2023-11-24T08:48:29.562Z',
              depositPercentage: 0,
              discount: 10,
              highlighted: false,
              imported: false,
              mandatory: false,
              price: 99.99999999999999,
              senderId: '0136b092-3d30-4e19-b645-e7ff48f1a762',
              sentOn: '2023-11-24T08:48:32.131Z',
              severity: 'PROPOSED',
              status: 'PENDING',
              version: 0,
              accepted: false,
              refused: false,
              proposed: true,
              discountedPrice: 89.99999999999999,
              hasDiscount: true,
              pending: true
            },
            {
              adviceId: 'c923dff9-1a27-408b-997c-b313cac34a81',
              adviceName: createLabel('Handbrake'),
              authorId: 'f17ec42b-eec4-4df1-a737-6a13bc4f6f58',
              coefficient: 1,
              createdOn: '2023-11-24T08:48:29.562Z',
              depositPercentage: 0,
              discount: 0,
              highlighted: false,
              imported: false,
              mandatory: false,
              price: 200,
              senderId: '0136b092-3d30-4e19-b645-e7ff48f1a762',
              sentOn: '2023-11-24T08:48:32.131Z',
              severity: 'PROPOSED',
              status: 'PENDING',
              version: 0,
              accepted: false,
              refused: false,
              proposed: true,
              discountedPrice: 200,
              hasDiscount: false,
              pending: true
            }
          ],
          categoryId: '657fd38d-553c-4543-befe-6918e67926f8',
          categoryName,
          others: true,
          price: 387
        }
      ],
      name: 'Parts',
      offeredChecklist: false,
      type: 'PARTS',
      price: 387,
      default: true,
      languages: ALL_LANGUAGES,
      projectionType: 'public',
    },
    {
      checklistGroupId: 'offer2id',
      items: [
        {
          advices: [
            {
              adviceId: 'e281eb03-2e5c-41b8-aa86-b5063c88c3a4',
              adviceName: createLabel('Battery'),
              authorId: 'f17ec42b-eec4-4df1-a737-6a13bc4f6f58',
              coefficient: 1,
              createdOn: '2023-11-24T08:48:29.564Z',
              depositPercentage: 0,
              discount: 2.9999999999999996,
              highlighted: true,
              imported: false,
              mandatory: false,
              price: 59.99999999999999,
              senderId: '0136b092-3d30-4e19-b645-e7ff48f1a762',
              sentOn: '2023-11-24T08:48:32.129Z',
              severity: 'PROPOSED',
              status: 'PENDING',
              version: 0,
              accepted: false,
              refused: false,
              proposed: true,
              discountedPrice: 56.99999999999999,
              hasDiscount: true,
              pending: true
            },
            {
              adviceId: '69a9684f-47d8-44dc-b7da-51886573068d',
              adviceName: createLabel('Windscreen wiper'),
              authorId: 'f17ec42b-eec4-4df1-a737-6a13bc4f6f58',
              coefficient: 1,
              createdOn: '2023-11-24T08:48:29.564Z',
              depositPercentage: 0,
              discount: 0,
              highlighted: false,
              imported: false,
              mandatory: false,
              price: 40,
              senderId: '0136b092-3d30-4e19-b645-e7ff48f1a762',
              sentOn: '2023-11-24T08:48:32.129Z',
              severity: 'OFFERED',
              status: 'PENDING',
              version: 0,
              accepted: false,
              refused: false,
              proposed: true,
              discountedPrice: 40,
              hasDiscount: false,
              pending: true
            },
            {
              adviceId: '2d17fed2-4993-4d03-bb34-a60a5eda8811',
              adviceName: createLabel('Brakes'),
              authorId: 'f17ec42b-eec4-4df1-a737-6a13bc4f6f58',
              coefficient: 1,
              createdOn: '2023-11-24T08:48:29.564Z',
              depositPercentage: 0,
              discount: 10,
              highlighted: false,
              imported: false,
              mandatory: false,
              price: 99.99999999999999,
              senderId: '0136b092-3d30-4e19-b645-e7ff48f1a762',
              sentOn: '2023-11-24T08:48:32.129Z',
              severity: 'PROPOSED',
              status: 'PENDING',
              version: 0,
              accepted: false,
              refused: false,
              proposed: true,
              discountedPrice: 89.99999999999999,
              hasDiscount: true,
              pending: true
            },
            {
              adviceId: '7ebfc93d-e34f-4783-a46d-34a25a7ef9c8',
              adviceName: createLabel('Handbrake'),
              authorId: 'f17ec42b-eec4-4df1-a737-6a13bc4f6f58',
              coefficient: 1,
              createdOn: '2023-11-24T08:48:29.564Z',
              depositPercentage: 0,
              discount: 0,
              highlighted: false,
              imported: false,
              mandatory: false,
              price: 200,
              senderId: '0136b092-3d30-4e19-b645-e7ff48f1a762',
              sentOn: '2023-11-24T08:48:32.129Z',
              severity: 'PROPOSED',
              status: 'PENDING',
              version: 0,
              accepted: false,
              refused: false,
              proposed: true,
              discountedPrice: 200,
              hasDiscount: false,
              pending: true
            },
            {
              adviceId: '071f0fdb-7666-438a-8be0-7e17ecc5492e',
              adviceName: createLabel('Tires x4'),
              authorId: 'f17ec42b-eec4-4df1-a737-6a13bc4f6f58',
              coefficient: 1,
              createdOn: '2023-11-24T08:48:29.564Z',
              depositPercentage: 0,
              discount: 0,
              highlighted: true,
              imported: false,
              mandatory: false,
              price: 400,
              senderId: '0136b092-3d30-4e19-b645-e7ff48f1a762',
              sentOn: '2023-11-24T08:48:32.129Z',
              severity: 'PROPOSED',
              status: 'PENDING',
              version: 0,
              accepted: false,
              refused: false,
              proposed: true,
              discountedPrice: 400,
              hasDiscount: false,
              pending: true
            }
          ],
          categoryId: '657fd38d-553c-4543-befe-6918e67926f8',
          categoryName,
          others: true,
          price: 787
        }
      ],
      name: 'Parts',
      offeredChecklist: false,
      type: 'PARTS',
      price: 787,
      default: true,
      languages: ALL_LANGUAGES,
      projectionType: 'public',
    }
  ]
};

const sections = [
  {
    id: 's1',
    questions: [
      {
        type: 'ReferenceResponse',
        id: 'q1',
        question: {
          type: 'ReferenceQuestion',
          title: {
            fr: 'Reference',
            nl: 'Reference',
          },
        },
        reference: 'Section Reference',
      },
      {
        type: 'AuthorResponse',
        id: 'q2',
        question: {
          type: 'AuthorQuestion',
          title: {
            fr: 'Auteur',
            nl: 'Auteur',
          },
        },
        author: 'a1',
      },
    ],
    title: { fr: 'Section 1', nl: 'Section 2' },
  },
  {
    id: 's2',
    questions: [
      {
        type: 'CheckboxResponse',
        id: 'q3',
        question: {
          type: 'CheckboxQuestion',
          title: {
            fr: 'Question',
            nl: 'Question',
          },
          choices: [
            {
              id: 'c1',
              labels: {
                fr: 'Réponse',
                nl: 'Réponse',
              },
            },
            {
              id: 'c2',
              labels: {
                fr: 'Réponse',
                nl: 'Réponse',
              },
            },
          ],
        },
        choices: ['c1'],
      },
      {
        type: 'EmployeeResponse',
        id: 'q4',
        question: {
          type: 'EmployeeQuestion',
          title: {
            fr: 'Technicien',
            nl: 'Technicien',
          },
          roles: ['TECHNICIAN'],
        },
        employee: 'e1',
      },
    ],
    title: {
      fr: 'Section 2',
      nl: 'Section 2',
    },
  },
  {
    id: 's3',
    questions: [
      {
        type: 'TextboxResponse',
        id: 'q5',
        question: {
          type: 'TextboxQuestion',
          title: {
            fr: 'Commentaire',
            nl: 'Commentaire',
          },
        },
      },
      {
        type: 'SignatureResponse',
        id: 'q6',
        question: {
          type: 'SignatureQuestion',
          title: {
            fr: 'Signature',
            nl: 'Signature',
          },
        },
        media: {
          id: 'm1',
          type: 'IMAGE',
        },
      },
    ],
    title: { fr: 'Section 3', nl: 'Section 3' },
  },
];

const intervention = {
  brand,
  checklists,
  customerInfo,
  message,
  sentBy,
  vehicleInfo,
  valueAddedTax: 20,
};

const audit = {
  author,
  customerInfo,
  description: createLabel('Audit Description'),
  languages: ALL_LANGUAGES,
  sections,
  title: createLabel('Audit Title'),
  vehicleInfo,
};

const Data = {
  intervention,
  audit,
  checklistsSales,
  parts,
};

export default Data;
